__turbopack_context__.v({
  "stadiumFansActions": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansActions",
  "stadiumFansBand": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBand",
  "stadiumFansBandInner": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBandInner",
  "stadiumFansBenefitDot": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBenefitDot",
  "stadiumFansBenefitItem": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBenefitItem",
  "stadiumFansBenefitText": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBenefitText",
  "stadiumFansBenefits": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBenefits",
  "stadiumFansBody": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBody",
  "stadiumFansBodyDesktop": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBodyDesktop",
  "stadiumFansBodyLine": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBodyLine",
  "stadiumFansBottomBlend": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansBottomBlend",
  "stadiumFansContactLink": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansContactLink",
  "stadiumFansContactText": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansContactText",
  "stadiumFansCopy": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansCopy",
  "stadiumFansDarken": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansDarken",
  "stadiumFansForeground": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansForeground",
  "stadiumFansGrain": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansGrain",
  "stadiumFansImage": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansImage",
  "stadiumFansPrimaryBtn": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansPrimaryBtn",
  "stadiumFansPrimaryBtnIcon": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansPrimaryBtnIcon",
  "stadiumFansPrimaryBtnText": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansPrimaryBtnText",
  "stadiumFansSecondaryBtn": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansSecondaryBtn",
  "stadiumFansSecondaryBtnText": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansSecondaryBtnText",
  "stadiumFansTitle": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansTitle",
  "stadiumFansTopBlend": "ForClubsCta-module-scss-module__bwUxDq__stadiumFansTopBlend",
});
